export const PUNCTUATOR_POST_URL = import.meta.env.VITE_PUNCTUATOR_POST_URL as string;
// TODO(rkjaran): default to window.location.protocol + "//" + window.location.host
export const TRANSCRIPT_SERVICE_HOST = (() => {
  const host = import.meta.env.VITE_TRANSCRIPT_SERVICE_HOST as string;
  return host.length !== 0 ? host : `${window.location.protocol}//${window.location.host}`;
})();
export const SPEECH_SERVICE_HOST = (() => {
  const host = import.meta.env.VITE_SPEECH_SERVICE_HOST as string;
  return host.length !== 0 ? host : `${window.location.protocol}//${window.location.host}`;
})();
export const SPEECH_RTG_SERVICE_HOST = (() => {
  const host = import.meta.env.VITE_SPEECH_RTG_SERVICE_HOST as string;
  return host.length !== 0 ? host : `${window.location.protocol}//${window.location.host}`;
})();
export const DEMO_STREAMING_SPEECH_SERVICE_HOST = import.meta.env.VITE_DEMO_STREAMING_SPEECH_SERVICE_HOST as string;
export const SPEECH_API_KEY = import.meta.env.VITE_SPEECH_API_KEY as string;
export const AUTH_REFRESH_URL = import.meta.env.VITE_AUTH_REFRESH_URL as string;
export const AUTH_INITTOKEN_URL = import.meta.env.VITE_AUTH_INITTOKEN_URL as string;
export const AUTH_LOGIN_BASE_URL = import.meta.env.VITE_AUTH_LOGIN_BASE_URL as string;
export const USAGE_INFO_API_URL = import.meta.env.VITE_USAGE_INFO_API_URL as string;
export const CAPTION_RTMP_API_URL = import.meta.env.VITE_CAPTION_RTMP_API_URL as string;
export const CAPTION_RTMP_STREAM_URL = import.meta.env.VITE_CAPTION_RTMP_STREAM_URL as string;
export const KEYCLOAK_ADMIN_GROUP = import.meta.env.VITE_KEYCLOAK_ADMIN_GROUP as string;
export const UPLOAD_LIMIT_B = import.meta.env.VITE_UPLOAD_LIMIT_B as string;
